import React from 'react';

// Material UI
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

// Components
import DashboardLayout from '../_layout/DashboardLayout/dashboard.layout';
import { PageTitle, SectionHeading } from '../../_core/_ui/typography.component';
import { InviteListContainer } from '../../Invite/InviteList/invite-list.container';
import InviteFormContainer from '../../Invite/InviteForm/invite-form.container';
import { PageHeaderRow, SectionWrapper } from '../../_core/_ui/structure.components';
import { MemberListGraphQL } from '../../Member/MemberList/member-list.graphql';
import { getAuthUser } from '../../../lib/services/auth.service';
import { PendingScoresListContainer } from '../../AdminOnly/pending-scores-list.container';
import { ROLES } from '../../../../_configuration';
import { hasAnyRoles } from '../../../lib/services/user.service';

export const ManageUsersPage = () => {
  const user = getAuthUser();

  // Check if user has user management permissions (same logic as navigation)
  const hasUserManagementPermissions = hasAnyRoles({ roles: [ROLES.USER_MANAGEMENT], anyAgeGroup: true });

  // If user doesn't have permissions, show error message
  if (!hasUserManagementPermissions) {
    return (
      <DashboardLayout hideAgeGroupFilter requiredRoles={[ROLES.USER_MANAGEMENT]}>
        <PageHeaderRow><PageTitle>Manage Users</PageTitle></PageHeaderRow>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SectionWrapper>
              <Typography variant="body1" style={{ color: '#f44336', fontWeight: 'bold' }}>
                Missing required permissions to manage users
              </Typography>
            </SectionWrapper>
          </Grid>
        </Grid>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout hideAgeGroupFilter requiredRoles={[ROLES.USER_MANAGEMENT]}>
      <PageHeaderRow><PageTitle>Manage Users</PageTitle></PageHeaderRow>
      <Grid container spacing={2}>
        <MemberListGraphQL />
        <Grid item xs={12}>
          <SectionWrapper>
            <SectionHeading>Send an Invite</SectionHeading>
            <InviteFormContainer />
          </SectionWrapper>
        </Grid>
        <Grid item xs={12} md={6}>
          <SectionWrapper>
            <SectionHeading>Pending Invites</SectionHeading>
            <InviteListContainer />
          </SectionWrapper>
        </Grid>
        {!!user?.isAdmin &&
          <Grid item xs={12} md={6}>
            <SectionWrapper>
              <SectionHeading>Pending Scores</SectionHeading>
              <PendingScoresListContainer />
            </SectionWrapper>
          </Grid>
        }
      </Grid>
    </DashboardLayout>
  );
};
